import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MarkupItemModel } from '@libs/form/models';
import { BypassSecurityPipe } from '@libs/shared/ui';
import { ItemBaseComponent } from '../../../models';

@Component({
  selector: 'ui-form-markup',
  template: '<div [innerHtml]="data.content | bypassSecurity" ></div>',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BypassSecurityPipe,
  ],
})
export class MarkupComponent extends ItemBaseComponent {
  @Input() public data!: MarkupItemModel;
}
